import React, {useState} from 'react';
import styles from './ChangesGroup.module.scss';
import {default as _} from '../../../helpers/Translate';
import Storage from "../../../helpers/Storage"
import Badge from 'react-bootstrap/Badge';


const ChangesGroup = ({items}) => {
    const [direction] = useState(Storage.directionGet())
    const [show, setShow] = useState(false)
    const [kinds] = useState([...new Set(items.changes.map(item => item.type))].sort().reverse())

    const click = () => {
        setShow(!show)
    }

    const expandable = () => {
        let expand_off = direction === "ltr" ? "fa fa-caret-right" : "fa fa-caret-left"
        return <span className={styles.group_clicker}>
            {show ? <i className={"fa fa-caret-down"}/> : <i className={expand_off}/>}
        </span>
    }

    const title = () => {
        return <span className={styles.group_title}>
                {_.init4("version_changes", {version: items.version})}
            </span>
    }

    const dots = () => {
        return kinds.map((it, index) => {
            switch (it) {
                case "New Feature":
                    return <span className={styles.group_dot_parent} key={index}>
                        <span className={styles.group_dot_new}> N </span>
                        <Badge className="badged position-absolute top-0 start-100 translate-middle">
                            {items.changes.filter(item => item.type === it).length}
                        </Badge>
                    </span>
                case "Fix Bug":
                    return <span className={styles.group_dot_parent} key={index}>
                        <span className={styles.group_dot_bug}> B </span>
                        <Badge className="badged position-absolute top-0 start-100 translate-middle">
                            {items.changes.filter(item => item.type === it).length}
                        </Badge>
                    </span>
                case "Improve Feature":
                    return <span className={styles.group_dot_parent} key={index}>
                        <span className={styles.group_dot_improve}> I </span>
                        <Badge className="badged position-absolute top-0 start-100 translate-middle">
                            {items.changes.filter(item => item.type === it).length}
                        </Badge>
                    </span>
                default:
                    return "none in list changes type"
            }
        })
    }

    const make_title = () => {
        return <div className={styles.whole_title}
                    onClick={click}
        >
            {expandable()}
            {title()}
            {dots()}
        </div>
    }

    const one_item = (ch) => {
        return <div className={"change__div"}>
            <div className={`change__div__title`}> {ch.title} :</div>
            <div className={"change__div__description"} dangerouslySetInnerHTML={{__html: ch.description}}/>
        </div>
    }

    const same_items = (lst) => {
        return <div className={styles[`group_same_items__${lst?.[0].type.replace(" ", "_")}`]}>
            <div> <span className={"group_changes_type_title"}> {lst?.[0].type}{"s"} : </span> </div>
            <ul>
                {lst?.map((it, index) => {
                    return <li key={index}> {one_item(it)} </li>
                })}
            </ul>
        </div>
    }

    const filter_similarity = () => {
        return kinds.map(ki => items.changes.filter(it => it.type === ki)).map(it => same_items(it))
    }


    return (
        <div className={styles.item_changes}
             style={{direction: direction, textAlign: direction === "ltr" ? "left" : "right"}}>
            <div className={styles.group_brief}>
                {make_title()}
            </div>

            <div className={styles.group_changes}>
                {show && filter_similarity()}
            </div>

        </div>
    );
};

export default ChangesGroup;